import { render, staticRenderFns } from "./select.vue?vue&type=template&id=2acd27c2&scoped=true&"
import script from "./select.js?vue&type=script&lang=js&"
export * from "./select.js?vue&type=script&lang=js&"
import style0 from "./select.vue?vue&type=style&index=0&id=2acd27c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acd27c2",
  null
  
)

export default component.exports